import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Card } from "./ui/card";
import { t } from "../lib/i18n";
import { LifeBuoy } from "lucide-react";

export default function CustomerLifeVests({ lang }) {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/my-life-vests").then((r) => setData(r.data)).catch(() => setData({ entries: [], total: 0 }));
  }, []);

  if (!data) return null;
  if (data.entries.length === 0) {
    return (
      <Card className="p-5" data-testid="customer-lifevests">
        <div className="flex items-center gap-2 mb-2">
          <LifeBuoy className="w-5 h-5 text-[#1DA3B3]" />
          <h2 className="text-xl font-bold text-[#0C1824]">{t(lang, "lifevests_title")}</h2>
        </div>
        <p className="text-sm text-[#2B3F4D]">{t(lang, "lifevests_empty")}</p>
      </Card>
    );
  }
  return (
    <Card className="p-5" data-testid="customer-lifevests">
      <div className="flex items-center justify-between gap-2 mb-3">
        <div className="flex items-center gap-2">
          <LifeBuoy className="w-5 h-5 text-[#1DA3B3]" />
          <h2 className="text-xl font-bold text-[#0C1824]">{t(lang, "lifevests_title")}</h2>
        </div>
        <div className="text-right">
          <div className="text-[10px] uppercase tracking-[0.18em] text-[#A57F39]">
            {t(lang, "lifevests_total")}
          </div>
          <div
            className="text-2xl font-bold text-[#0C1824]"
            data-testid="customer-lifevests-total"
          >
            {data.total} <span className="text-sm font-normal text-[#2B3F4D]">{t(lang, "lifevests_count_unit")}</span>
          </div>
        </div>
      </div>
      <div className="space-y-1">
        {data.entries.map((e, i) => (
          <div
            key={i}
            className="flex items-center justify-between py-1.5 border-b border-slate-100 last:border-0"
            data-testid={`customer-lifevest-entry-${i}`}
          >
            <span className="text-sm text-[#0C1824]">{e.size}</span>
            <span className="font-mono text-sm text-[#A57F39]">× {e.quantity}</span>
          </div>
        ))}
      </div>
    </Card>
  );
}
